/* eslint semi:0 */
import { warn, } from 'application/console'
import { getElementById, } from 'utils/dom'
import dialogPolyfill from 'dialog-polyfill'
import { mount, unmount, } from 'utils/component'
import { registerInNamespace, } from 'application/nm'
import modalComponent from 'components/modalComponent'
import { closeModal as closeModalAction, } from 'actions/modalActions'
import { SELECTORS, MOUNT_POINTS, } from 'config/preRenderedSelectorsConfig'


let dialog = {}
const rootDialog = getElementById(SELECTORS.MODAL.slice(1))
const mountPoint = rootDialog && rootDialog.querySelector(MOUNT_POINTS.MODAL__MOUNT_POINT)

const d = document

const { classList: bodyClasses, } = d.body

const CLASS_NAMES = {
  HAS_MODAL: 'has-modal',
}
const IS_MODAL = true

function onClose(e){
  bodyClasses.remove(CLASS_NAMES.HAS_MODAL)
  unmount(mountPoint)
}

if (rootDialog) {
  dialogPolyfill.registerDialog(rootDialog)
  rootDialog.addEventListener('click', function clickModal(ev){
    if (ev.target === rootDialog) {
      closeModalAction(ev)
    }
  })

  const closeModalButton = rootDialog.querySelector(SELECTORS.MODAL__CLOSE_BUTTON)
  closeModalButton.addEventListener('click', closeModalAction)

  rootDialog.addEventListener('close', onClose, false)

  const modal = {
    get isOpen(){
      return rootDialog.open
    },
    get isClosed(){
      return !modal.isOpen
    },
    show(component){
      if (modal.isClosed) {
        mount({ rootNode: mountPoint, component, })
        rootDialog.showModal(IS_MODAL)
        bodyClasses.add(CLASS_NAMES.HAS_MODAL)
        modal.currentComponent = component
      }
      return modal
    },
    close(e){
      rootDialog.close()
      return modal
    },
  }

  mount({
    modal,
    rootNode: mountPoint,
    component: modalComponent,
  })

  dialog = {
    modal,
    rootDialog,
    polyfill: dialogPolyfill,
  }
} else {
  warn('Trying to initialize dialog provider without a mount point!', {
    rootDialog,
    dialog,
  })
}

registerInNamespace({ dialog, })

export default dialog


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/dialogProvider.js